<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* =============================================================================
   Disabilita il filtro nativo Ella "variant image group" (Sistema A).
   theme.js:5197 initVariantImageGroup -> setImage -> unFilter() rimette TUTTE le
   slide ad ogni cambio variante = flash "gallery completa non filtrata". Compete
   con il filtro custom filterThumbnails() in variants.js, che deve restare l'unico
   owner della gallery (graduale + tiene le immagini libere, vedi handoff.md).
   Gli snippet product-page-* col toggle OFF emettono window.variant_image_group =
   'false' (STRINGA, truthy) e theme.js:4522 la passa cruda a if(enable) -> Sistema A
   resta attivo comunque. Lo forziamo a false (boolean). custom.js e' parser-blocking
   (theme.liquid:148) e gira PRIMA di theme.js (defer) -> initVariantImageGroup legge
   false -> non si aggancia. Idem per il quick view.
   ============================================================================= */
window.variant_image_group = false;
window.variant_image_group_quick_view = false;

/* =============================================================================
   Immagine del prodotto configurato nel carrello.
   Il configuratore (app gtc-configurator) non crea piu' un prodotto Shopify: aggiunge
   la variante reale e allega la configurazione come line item properties, fra cui
   `_configured_image` = url CDN dell'immagine composta.
   Shopify usa sempre l'immagine della variante nelle righe carrello, quindi qui la
   sostituiamo lato client su tutte le UI carrello del tema (pagina carrello, side
   cart, popup quick cart), che vengono ri-renderizzate via ajax.
   NB: il checkout resta con l'immagine del prodotto base, non e' sovrascrivibile.
   ============================================================================= */
(function () {
    var PROPERTY = '_configured_image';
    var LINE_SELECTOR = '.cart-item[data-item-row], .previewCartItem[data-item-row]';
    var IMAGE_SELECTOR = '.cart-item-image img, .previewCartItem-image img';
    var DONE_ATTRIBUTE = 'data-configured-image';
    /* Le miniature carrello del tema non superano i 200px CSS: 400 copre il retina. */
    var THUMBNAIL_WIDTH = 400;

    function pendingLines() {
        return document.querySelectorAll(LINE_SELECTOR.split(', ').map(function (selector) {
            return selector + ':not([' + DONE_ATTRIBUTE + '])';
        }).join(', '));
    }

    function sizedUrl(url, width) {
        try {
            var parsed = new URL(url, window.location.origin);
            parsed.searchParams.set('width', String(width));
            return parsed.toString();
        } catch (error) {
            return url;
        }
    }

    function applyImage(line, url) {
        var image = line.querySelector(IMAGE_SELECTOR);
        if (!image) return;

        image.src = sizedUrl(url, THUMBNAIL_WIDTH);
        image.srcset = sizedUrl(url, THUMBNAIL_WIDTH);
        image.removeAttribute('height');
    }

    /* Le righe non espongono tutte la chiave della linea: quelle che ce l'hanno
       (data-line) si abbinano per chiave, le altre per posizione dentro la loro lista. */
    function applyToLines(lines, cart) {
        var lists = new Map();

        lines.forEach(function (line) {
            var list = line.parentElement;
            if (!lists.has(list)) lists.set(list, []);
            lists.get(list).push(line);
        });

        lists.forEach(function (list) {
            list.forEach(function (line, index) {
                line.setAttribute(DONE_ATTRIBUTE, '1');

                var key = line.getAttribute('data-line');
                var item = key
                    ? cart.items.find(function (cartItem) { return cartItem.key === key; })
                    : null;

                if (!item) item = cart.items[index];
                if (!item || !item.properties) return;

                var url = item.properties[PROPERTY];
                if (url) applyImage(line, url);
            });
        });
    }

    var scheduled = false;

    function scheduleUpdate() {
        if (scheduled) return;
        scheduled = true;

        setTimeout(function () {
            scheduled = false;

            var lines = Array.prototype.slice.call(pendingLines());
            if (!lines.length) return;

            fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (response) { return response.json(); })
                .then(function (cart) {
                    if (cart && cart.items) applyToLines(lines, cart);
                })
                .catch(function (error) {
                    console.error('Configured image: unable to read the cart', error);
                });
        }, 100);
    }

    function start() {
        scheduleUpdate();

        new MutationObserver(function () {
            if (pendingLines().length) scheduleUpdate();
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
